export const breakpoints = {
  tablet: '1024px',
  desktopSmall: '1440px',
  desktopLarge: '1920px',
};
